import { Submission } from '../../types';
import { apiError } from '../../utils/errors';

export const resendToken = async (
  urlSlug: string,
  publicId: string,
): Promise<Submission> => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/submissions/${urlSlug}/${publicId}/tokens/resend`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  });
  const responseJson = await response.json();
  if (!response.ok) {
    throw apiError(response.status, responseJson?.message || 'Failed to fetch application');
  }

  return responseJson;
};
